// extracted by mini-css-extract-plugin
module.exports = {"customModal":"ActivityLogModal_customModal__11L2O","tableContainer":"ActivityLogModal_tableContainer__1419Y"};